<template>
  <div class="course-list">
    <div v-for="(course, index) in courseData" :key="index" class="course-item">
      <div class="course-title" @click="toggleCourse(index)">
        <span>第{{ index + 1 }}册 《{{ course.title }}》</span>
        <span class="toggle-icon">{{ expandedCourses[index] ? '▼' : '▶' }}</span>
      </div>
      
      <div v-if="expandedCourses[index]" class="lessons-container">
        <div v-for="(lesson, lessonIndex) in course.lessons" :key="lessonIndex" class="lesson-item">
          <div 
            v-if="index === 0 && lessonIndex === 0" 
            class="current-lesson"
            @click="selectLesson(index, lessonIndex)"
          >
            第{{ lessonIndex + 1 }}课 {{ lesson }}
          </div>
          <div 
            v-else 
            class="lesson" 
            :class="{'locked': !isLessonUnlocked(index, lessonIndex), 'active': isSelected(index, lessonIndex)}"
            @click="isLessonUnlocked(index, lessonIndex) && selectLesson(index, lessonIndex)"
          >
            <span class="lesson-title">第{{ lessonIndex + 1 }}课 {{ lesson }}</span>
            <span v-if="!isLessonUnlocked(index, lessonIndex)" class="lock-icon">🔒</span>
          </div>
          
          <!-- 显示当前选中课程的音频播放器 -->
          <div v-if="isSelected(index, lessonIndex)" class="lesson-player">
            <AudioPlayer 
              :audio-src="getAudioSrc(index, lessonIndex)" 
              :lesson-title="`第${lessonIndex + 1}课 ${lesson}`"
              :course-index="index"
              :lesson-index="lessonIndex"
            />
          </div>
        </div>
      </div>
      
      <div v-if="index === 0 && !expandedCourses[0]" class="dot-indicators">
        <div class="dot"></div>
        <div class="dot"></div>
        <div class="dot"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue'
import AudioPlayer from './AudioPlayer.vue'

export default {
  name: 'CourseList',
  components: {
    AudioPlayer
  },
  props: {
    courseData: {
      type: Array,
      required: true
    },
    isActivated: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    const expandedCourses = ref([true, false, false, false])
    const selectedCourse = ref(0)
    const selectedLesson = ref(0)
    
    const toggleCourse = (index) => {
      expandedCourses.value[index] = !expandedCourses.value[index]
    }
    
    const isLessonUnlocked = (courseIndex, lessonIndex) => {
      // 第一册第一课总是解锁的
      if (courseIndex === 0 && lessonIndex === 0) {
        return true
      }
      
      // 其他课程需要激活才能解锁
      return props.isActivated
    }
    
    const selectLesson = (courseIndex, lessonIndex) => {
      // 只有解锁的课程可以选择
      if (!isLessonUnlocked(courseIndex, lessonIndex)) {
        return
      }
      
      selectedCourse.value = courseIndex
      selectedLesson.value = lessonIndex
      
      // 确保相应的课程已展开
      expandedCourses.value[courseIndex] = true
    }
    
    const isSelected = (courseIndex, lessonIndex) => {
      return selectedCourse.value === courseIndex && selectedLesson.value === lessonIndex
    }
    
    const getAudioSrc = (courseIndex, lessonIndex) => {
      // 使用本地音频文件路径
      return `/audio/course${courseIndex + 1}/lesson${lessonIndex + 1}/audio.mp3`
    }
    
    onMounted(() => {
      // 默认选中第一课
      selectLesson(0, 0)
    })
    
    return {
      expandedCourses,
      toggleCourse,
      isLessonUnlocked,
      selectLesson,
      isSelected,
      getAudioSrc
    }
  }
}
</script>

<style scoped>
.course-list {
  display: flex;
  flex-direction: column;
  gap: 30px;
}

.course-item {
  border-radius: 8px;
  overflow: hidden;
  background-color: #fafafa;
  padding: 16px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.course-title {
  font-size: 22px;
  font-weight: bold;
  margin-bottom: 15px;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 8px;
  border-bottom: 1px solid #eee;
}

.toggle-icon {
  font-size: 14px;
  color: #666;
}

.lessons-container {
  margin-left: 20px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.lesson-item {
  font-size: 18px;
  padding: 8px 0;
  transition: all 0.2s;
}

.lesson {
  cursor: pointer;
  color: #333;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.lesson:hover {
  color: #000;
}

.lesson.active {
  font-weight: bold;
  color: #000;
}

.lesson.locked {
  color: #999;
  cursor: not-allowed;
}

.lock-icon {
  font-size: 16px;
  color: #999;
}

.current-lesson {
  font-weight: bold;
  font-size: 20px;
  color: #000;
  position: relative;
  padding-left: 16px;
  cursor: pointer;
}

.current-lesson::before {
  content: '';
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 6px;
  height: 16px;
  background-color: #000;
  border-radius: 3px;
}

.dot-indicators {
  display: flex;
  justify-content: center;
  gap: 12px;
  margin: 20px 0 10px;
}

.dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #000;
}

.lesson-player {
  margin-top: 10px;
  margin-bottom: 15px;
}
</style> 